import { Pipe, PipeTransform } from '@angular/core';


/**
 * Pipe to replace arguments of label.
 */
@Pipe({
	name: 'replace'
})
export class ReplacePipe implements PipeTransform {

	transform(label: string, ...args: any): string {
		for (let index = 0; index < args.length; index++) {
			label = label?.replace(`{{${index+1}}}`, args[index]);
		}
		return label;
	}

}
